import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Отправить запрос на получение уведомлений
export const getNotifications = async (page = 1) => {
  const url = `${backendUrl}/api/notifications/?page=${page}`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении уведомлений: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка получения уведомлений:', error);
    throw error;
  }
};
